import zlib from 'pako';
import { SharingData } from './api';

const FALLBACK_ZL_SERVICE = "stage";

const getServiceUrl = (zlservice: string) => {
	return `https://shortcode-${zlservice}.brp.zlthunder.net`;
}

export const save = async (userId: string, prcodes: string[], api: number, state: object, sharing: SharingData, zlservice: string) : Promise<string> => {
	const blob = {
		api,
		state: btoa(zlib.deflate(JSON.stringify(state), {to: 'string'})),
		sharing
	}

	const blobsize = JSON.stringify(blob).length;
	if(blobsize > 4096) {
		throw `State information too long, ${blobsize} > 4096`
	}

	const url = getServiceUrl(zlservice) + "/code";

	const response = await fetch(url, {
		method: "POST",
		headers: {
			'accept': 'application/json',
			'content-type': 'application/json'
		},
		body: JSON.stringify({
			clientApplication: "BRP API",
			sessionId: userId,
			productionCodes: prcodes,
			blob
		})
	})

	if(!response.ok) {
		throw new Error("Failed to get shortcode");
	}

	const data = await response.json()

	if(!data.shortCode) {
		throw new Error("Failed to get shortcode");
	}

	return data.shortCode;
}

export const load = async (shortcode: string, zlservice: string) : Promise<{api: number, state: any}> => {
	return await fetch(getServiceUrl(zlservice) + "/code/" + shortcode, {
		method: "GET",
		headers: {
			'accept': 'application/json'
		},
	}).then((response) => {
		return response.json();
	}).then(async (json) => {
		if(!json.blob && zlservice !== FALLBACK_ZL_SERVICE && (json.errorMessage === "Short code does not exist" || json.errorMessage === "Failed to get pr codes from recovery db")) {
			return await load(shortcode, FALLBACK_ZL_SERVICE)
		}
		if(undefined === json.blob)
			return { api: -1, state: { error: `'blob' not found in 'json'\n\t${Object.keys(json)}\n\t${json}` } }

		const state = JSON.parse(zlib.inflate(atob(json.blob.state), {to: 'string'}));
		console.log("Shortcode loaded: " + shortcode, state)
		return {api: json.blob.api, state};
	})
}